import { classNames, React } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { styles } from './Step.scss';

const cx = classNames.bind(styles);

export const Step = ({ children }) => (
  <div className={cx('c-auth-modal-step')}>{children}</div>
);

Step.propTypes = {
  children: PropTypes.any,
};
